// Configuración del modo kiosco del tótem.
// Gesto secreto para salir de pantalla completa: tocar N veces la esquina definida.

// PIN para salir del modo tótem. CÁMBIALO por el del local.
export const EXIT_PIN = '9999';

// Esquina donde está la zona secreta: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right'
// (el logo usa abajo-izquierda para ENTRAR a fullscreen, así que aquí usamos arriba-izquierda)
export const EXIT_CORNER = 'top-left';

// Cuántos toques seguidos y en cuánto tiempo (ms) para gatillar el PIN.
export const EXIT_TAPS = 5;
export const EXIT_WINDOW_MS = 3000;

// Tamaño (px) de la zona secreta invisible en la esquina.
export const EXIT_ZONE_PX = 80;
